import { Link } from '@mui/material'
import { Navigate, Outlet, UIMatch } from 'react-router-dom'
import { DynamicBreadcrumb } from './breadcrumbs'
import { routePaths } from './route-paths'
import { CsRoute } from './types'
import { prepareRoutes } from './utils/prepareRoutes'

export const useCorestreamProductsRoutes = (): CsRoute[] => {
	return [
		{
			path: routePaths.productTypes.root,
			element: <Outlet />,
			handle: {
				crumb: () => <Link href={routePaths.productTypes.root}>Product Types</Link>,
			},
			children: prepareRoutes(
				[
					{
						lazy: () =>
							import('routes/product-type-routes').then((module) => ({
								Component: module.ProductTypeRoutes,
							})),
						path: routePaths.productTypes.edit.root,
						children: prepareRoutes(
							[
								{
									path: '*',
									element: <Navigate to={'details'} replace />,
								},
								{
									path: routePaths.productTypes.edit.details.path,
									lazy: () =>
										import('pages/product-types/product-overview/product-overview').then((module) => ({
											Component: module.default,
										})),
									handle: {
										crumb: () => <div>Overview</div>,
									},
								},
								{
									path: routePaths.productTypes.edit.productPageContent.path,
									lazy: () =>
										import('pages/product-types/product-page-content/product-page-content').then((module) => ({
											Component: module.default,
										})),
									handle: {
										crumb: () => <div>Product Page Content</div>,
									},
								},
								{
									path: routePaths.productTypes.edit.tokens.path,
									lazy: () =>
										import('pages/product-types/tokens/product-type-tokens').then((module) => ({
											Component: module.default,
										})),
									handle: {
										crumb: () => <div>Tokens</div>,
									},
								},
								{
									path: routePaths.productTypes.edit.marketingContents.path,
									lazy: () =>
										import('pages/product-type-templates-marketing-contents').then((module) => ({
											Component: module.default,
										})),
									handle: {
										crumb: () => <div>Templates + Marketing Contents</div>,
									},
								},
							],
							{
								stripLeading: `${routePaths.productTypes.edit.root}/`,
							},
						),
						handle: {
							crumb: (data: UIMatch<any, any>) => (
								<DynamicBreadcrumb portalId={data.params.corestreamProductId ?? ''} />
							),
						},
					},
					{
						lazy: () =>
							import('routes/product-type-routes').then((module) => ({
								Component: () => <module.ProductTypeRoutes isEditing={true} />,
							})),
						path: '*',
						children: prepareRoutes(
							[
								{
									path: '*',
									element: <Navigate to={'create/overview'} replace />,
								},
								{
									path: routePaths.productTypes.create.path,
									lazy: () =>
										import('pages/product-types/product-overview/product-overview').then((module) => ({
											Component: module.default,
										})),
									handle: {
										crumb: () => <Link href={routePaths.productTypes.create.path}>Create Product Type</Link>,
									},
								},
							],
							{ stripLeading: `${routePaths.productTypes.root}/` },
						),
					},
					{
						index: true,
						lazy: () =>
							import('pages/product-types/products/products').then((module) => ({ Component: module.default })),
					},
				],
				{ stripLeading: `${routePaths.productTypes.root}/` },
			),
		},
	]
}
